"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFlavourProperty = exports.flavourPropertyDefinition = void 0;
exports.flavourPropertyDefinition = {
    name: 'flavour',
    type: 'text',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 45,
        },
    ],
    multiple: false,
    view: {
        label: 'Flavour',
        hint: 'The name of this edition\'s flavour, which is displayed on the can itself.',
        style: '',
    },
};
const isFlavourProperty = (prop) => {
    return prop.name === exports.flavourPropertyDefinition.name;
};
exports.isFlavourProperty = isFlavourProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhdm91ci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ZsYXZvdXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxJQUFJLEVBQUUsU0FBUztJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxTQUFTO1FBQ2hCLElBQUksRUFBRSw0RUFBNEU7UUFDbEYsS0FBSyxFQUFFLEVBQUU7S0FDVjtDQUM4QixDQUFBO0FBSTFCLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxJQUFrQixFQUEyQixFQUFFO0lBQy9FLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpQ0FBeUIsQ0FBQyxJQUFJLENBQUE7QUFDckQsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQkFBaUIscUJBRTdCIn0=